
declare global {
  interface Window {
    $: any;
    jQuery: any;
  }
}
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Selectize: () => import("vue2-selectize"),
    Slick: () => import("vue-slick")
  },
  computed: {
    isMobile() {
      return window.innerWidth < 992;
    }
  }
})
export default class CompaniesAdd extends Vue {
  title: string = "Agregar Empresa";
  subtitle: string = "Introduzca los datos de la empresa a dar de alta.";
  company: Record<string, any> = {
    handle_exclusion_contract: 0,
    countryId: "",
    renovation_company: "",
    adminId: "",
    name: "",
    ownerFirstName: "",
    ownerLastName: "",
    email: "",
    type_id: ""
  };
  countries: any = [];
  adminRoles: any = [];
  businessTypes: any = [];
  errors: Record<string, string> = {};
  steps: Record<number, boolean> = {
    0: true,
    1: false,
    2: false
  };
  selectizeOptions: Record<string, any> = {
    delimiter: ",",
    persist: false
  };
  slickOptions: Record<string, any> = {
    slidesToShow: 3,
    centerPadding: "60px",
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false
        }
      }
    ]
  };
  selected: any = [];

  clearFieldError(fieldName: string) {
    if (this.errors[fieldName]) {
      this.$delete(this.errors, fieldName);
    }
  }

  validateStep1() {
    this.errors = {};
    let valid = true;

    if (!this.company.name || !this.company.name.trim()) {
      this.$set(this.errors, 'name', 'Este campo es obligatorio');
      valid = false;
    }

    if (!this.company.countryId) {
      this.$set(this.errors, 'countryId', 'Debe seleccionar un país');
      valid = false;
    }

    return valid;
  }

  validateStep2() {
    let valid = true;

    if (!this.company.ownerFirstName || !this.company.ownerFirstName.trim()) {
      this.$set(this.errors, 'ownerFirstName', 'Este campo es obligatorio');
      valid = false;
    }

    if (!this.company.ownerLastName || !this.company.ownerLastName.trim()) {
      this.$set(this.errors, 'ownerLastName', 'Este campo es obligatorio');
      valid = false;
    }

    if (!this.company.email || !this.company.email.trim()) {
      this.$set(this.errors, 'email', 'Este campo es obligatorio');
      valid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.company.email.trim())) {
        this.$set(this.errors, 'email', 'El formato del email no es válido');
        valid = false;
      }
    }

    if (this.isSuper && !this.company.type_id) {
      this.$set(this.errors, 'type_id', 'Debe seleccionar un tipo de empresa');
      valid = false;
    }

    return valid;
  }

  move(index: number) {
    if (this[`validateStep${index}`]()) {
      (this.$refs.slick as any).goTo(index);
      this.steps[index] = true;
    }
  }

  async save() {
    if (!this.validateStep2()) return;

    let response: any = null;
    if (this.company.adminId == "null") this.company.adminId = null;

    const payload = {
      ...this.company,
      type_id: !this.isSuper ? this.$store.state.user.business_type_id : this.company.type_id
    };

    if (this.$route.params.id) {
      response = await (this.$root as any)._put(
        `businesses/${this.$route.params.id}`,
        payload
      );
    } else {
      response = await (this.$root as any)._post("businesses", payload);
    }
    this.$router.push("/admin/companies");
  }

  async loadBusiness() {
    try {
      const response: any = await (this.$root as any)._get(`businesses/one/${this.$route.params.id}`);
      this.company = { ...this.company, ...response.data };
      const owner = response.data.owners && response.data.owners[0];
      if (owner) {
        const nameParts = (owner.name || '').split(' ');
        this.company.ownerFirstName = nameParts[0] || '';
        this.company.ownerLastName = nameParts.slice(1).join(' ') || '';
        this.company.email = owner.email || '';
      }
    } catch (e) {
      console.log(e);
    }
  };

  async init() {
    await this.loadCountries();
    await this.loadBusinessTypes();
    await this.loadAdminRoles();
    if (this.$route.params.id) {
      this.loadBusiness();
    }
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
  }

  async loadBusinessTypes() {
    const response: any = await (this.$root as any)._get("business-types");
    this.businessTypes = response.data;
  }

  async loadAdminRoles() {
    const response: any = await (this.$root as any)._get("admins/getroles");
    this.adminRoles = response;
  }

  get isSuper() {
    return !Boolean(this.$store.state.user.business_type_id);
  }

}
